import { ApiService } from "../services/api.service";
import {
  State,
  Action,
  StateContext,
  Store,
  Selector,
  createSelector,
} from "@ngxs/store";
import { DeliveryStateModel } from "../interface/delivery";
import { UserState } from "./user.state";
import { tap, take, catchError } from "rxjs/operators";
import { of } from "rxjs";
import * as geofirex from "geofirex";
import { Navigate } from "@ngxs/router-plugin";
import * as turf from "@turf/turf";
import { Injectable } from "@angular/core";
declare let google;
import firebase from "firebase/compat/app";
import { AlertService } from "../services/alert.service";
import {
  CalculateNextPoint,
  ChangeBillDetailState,
  ClearWatchId,
  CreateDelivery,
  DeliveryNextPoint,
  DeliveryUserPosition,
  FinishBillDelivery,
  GetBillsDelivery,
  GetBillsForDelivery,
  GetDeliveryByUser,
  GetUserForBillDelivery,
  RegisterDelivery,
  SetBills,
  SetPosition,
  SetWatchId,
  UpdateBillAsNotDelivered,
  UpdateBillDetailState,
  UpdateDeliveryCoin,
  UpdateDeliveryState,
  UpdateNextPointOfDelivery,
  UpdateRadius,
} from "./actions/delivery.actions";

@State<DeliveryStateModel>({
  name: "delivery",
  defaults: {
    position: null,
    deliveryInfo: null,
    radius: 10,
    UserSelectedForBill: null,
    BlackBox: null,
    DeliveryCoin: null,
    isTransactionValid: false,
    transactionState: false,
    usersForBill: [],
  },
})
@Injectable()
export class DeliveryState {
  matrixService: any;
  private GeoFireX = geofirex.init(firebase);
  billsQuery: geofirex.GeoFireCollectionRef;
  watchId: number;

  constructor(
    private api: ApiService,
    private store: Store,
    private alertService: AlertService
  ) {}

  @Selector([UserState.me])
  static placeToDelivery(
    { ShopperOrdersA, deliveryInfo, ShopperOrdersB },
    { DeliveryRole: { Name_Role } }
  ) {
    if (deliveryInfo.TypeNextPoint_Delivery === 1) {
      const filtered =
        Name_Role === "Comprador"
          ? ShopperOrdersB.filter(
              (_detail) =>
                _detail.ProductFeature.Product.Inventory.Cellar.Place.Address
                  .id === deliveryInfo.NextPoint.id
            )
          : ShopperOrdersA.map((_order) => {
              return _order.Detail.filter(
                (_detail) =>
                  _detail.ProductFeature.Product.Inventory.Cellar.Place.Address
                    .id === deliveryInfo.NextPoint.id
              );
            }).filter((_order) => _order.length > 0);
      return Name_Role === "Comprador"
        ? filtered[0].ProductFeature.Product.Inventory.Cellar.Place
        : filtered[0][0].ProductFeature.Product.Inventory.Cellar.Place;
    } else {
      return ShopperOrdersA.find(
        (_order) => _order.Address.id === deliveryInfo.NextPoint.id
      );
    }
  }

  @Selector()
  static placeInDelivery({ deliveryOrders, deliveryInfo }) {
    if (deliveryInfo.TypeNextPoint_Delivery === 1) {
      const filtered = deliveryOrders
        .map((order) => {
          return order.Detail.filter(
            (detail) =>
              detail.ProductFeature.Product.Inventory.Cellar.Place.Address
                .id === deliveryInfo.NextPoint.id
          );
        })
        .filter((order) => order.length > 0);
      return filtered[0][0].ProductFeature.Product.Inventory.Cellar.Place;
    } else {
      return deliveryOrders.find(
        (order) => order.Address.id === deliveryInfo.NextPoint.id
      );
    }
  }

  static productsInDelivery(
    filteredItemsNotFounded: boolean,
    filteredDetailBills: boolean,
    filteredItemsOfDelivery: boolean
  ) {
    return createSelector(
      [DeliveryState, UserState.me],
      ({ deliveryInfo, deliveryOrders }, { DeliveryRole: { Name_Role } }) => {
        if (deliveryOrders && deliveryInfo) {
          let dataToReturn: any;
          let filter = !filteredItemsNotFounded
            ? filteredDetailBills
              ? 2
              : 1
            : 3;
          filter = filteredItemsOfDelivery ? 5 : 6;

          dataToReturn = deliveryOrders
            .map((order) => {
              const details = order.Detail.filter(
                (detail) =>
                  detail.ProductFeature.Product.Inventory.Cellar.Place.Address
                    .id === deliveryInfo.NextPoint.id &&
                  detail.State.id === filter
              );
              return {
                Bill: {
                  id: order.id,
                  Details_Bill: order.Details_Bill,
                  FirebaseId_Bill: order.FirebaseId_Bill,
                  OrderDate_Bill: order.OrderDate_Bill,
                  User: order.User,
                },
                details,
              };
            })
            .filter((order) => order.details.length > 0);

          if (dataToReturn.length === 0) {
            return null;
          } else {
            return dataToReturn;
          }
        } else {
          return null;
        }
      }
    );
  }

  @Selector()
  static billReadyToDelivery({
    deliveryOrders,
    deliveryInfo,
  }: DeliveryStateModel) {
    const places = deliveryOrders.filter(
      (order) => order.Address.id === deliveryInfo.NextPoint.id
    );
    if (places.length > 0) {
      return places;
    }
    return null;
  }

  @Selector([UserState.me])
  static billState({ deliveryInfo, deliveryOrders }: DeliveryStateModel) {
    let isNotComplete = false;
    let isNotFounded = false;
    const filtered = deliveryOrders
      .map((order) => {
        return order.Detail.filter(
          (detail) =>
            detail.ProductFeature.Product.Inventory.Cellar.Place.Address.id ===
            deliveryInfo.NextPoint.id
        );
      })
      .filter((order) => order.length > 0);
    filtered.forEach((element) => {
      element.forEach((detail) => {
        if (detail.State.id === 1 || detail.State.id === 6) {
          isNotComplete = true;
        } else if (detail.State.id === 3) {
          isNotFounded = true;
        }
      });
    });
    return { isNotComplete, isNotFounded, filtered };
  }

  @Selector()
  static position(state: DeliveryStateModel) {
    return state.position;
  }

  @Selector()
  static deliveryInfo(state: DeliveryStateModel) {
    return state.deliveryInfo;
  }

  @Selector()
  static bills({ bills }: DeliveryStateModel) {
    return bills;
  }

  @Selector()
  static watchId({ watchId }: DeliveryStateModel) {
    return watchId;
  }

  @Selector()
  static radius({ radius }: DeliveryStateModel) {
    return radius;
  }

  @Selector()
  static UserSelectedForBill(state: DeliveryStateModel) {
    return state.UserSelectedForBill;
  }

  @Selector()
  static BlackBox(state: DeliveryStateModel) {
    return state.BlackBox;
  }

  @Selector()
  static DeliveryCoin(state: DeliveryStateModel) {
    return state.DeliveryCoin;
  }

  @Selector()
  static isTransactionValid(state: DeliveryStateModel) {
    return state.isTransactionValid;
  }

  @Selector()
  static usersForBill(state: DeliveryStateModel) {
    return state.usersForBill;
  }

  @Selector([UserState.me])
  static isDelivery(_, { DeliveryRole: { Name_Role } }) {
    return Name_Role === "Delivery";
  }

  @Selector()
  static billsExist({ bills }: DeliveryStateModel) {
    return !!bills && bills.length > 0;
  }

  @Selector()
  static deliveryOrders({ deliveryOrders }: DeliveryStateModel) {
    return deliveryOrders;
  }

  @Selector()
  static prepareOrders({ prepareOrders }: DeliveryStateModel) {
    return prepareOrders;
  }

  ngxsOnInit({}: StateContext<DeliveryStateModel>) {
    this.matrixService = new google.maps.DistanceMatrixService();
  }

  @Action(SetPosition)
  setPosition(
    { patchState, dispatch, getState }: StateContext<DeliveryStateModel>,
    {}: SetPosition
  ) {
    const watchId = navigator.geolocation.watchPosition(
      ({
        coords: {
          accuracy,
          altitude,
          altitudeAccuracy,
          heading,
          latitude,
          longitude,
          speed,
        },
        timestamp,
      }) => {
        const position = {
          coords: {
            accuracy,
            altitude,
            altitudeAccuracy,
            heading,
            latitude,
            longitude,
            speed,
          },
          timestamp,
        };
        patchState({ position });
        dispatch(new DeliveryUserPosition(position));
        const place = this.store.selectSnapshot(DeliveryState.placeInDelivery);
        if (place && getState()) {
          const {
            deliveryInfo: { TypeNextPoint_Delivery, id },
          } = getState();
          const {
            Address: { Lng_Address, Lat_Address },
          } = place;
          const to = turf.point([
            position.coords.longitude,
            position.coords.latitude,
          ]);
          const from = turf.point([Lng_Address, Lat_Address]);
          const meters = turf.distance(from, to, { units: "meters" });
          if (meters <= 100) {
            dispatch(
              new UpdateDeliveryState(id, TypeNextPoint_Delivery === 1 ? 2 : 3)
            );
          }
        }
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          this.alertService.openSnackBar(
            "Usuario denegó permisos de Geolocalización.",
            "warn",
            
          );
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          this.alertService.openSnackBar(
            "Geolocalización no disponible.",
            "warn",
            
          );
        } else if (error.code === error.TIMEOUT) {
          this.alertService.openSnackBar(
            "Tiempo de respuesta agotado.",
            "warn",
            
          );
        }
      },
      { enableHighAccuracy: true }
    );
    patchState({ watchId });
  }

  @Action(DeliveryUserPosition)
  deliveryUserPosition(
    {}: StateContext<DeliveryStateModel>,
    { position }: DeliveryUserPosition
  ) {
    return this.api.deliveryUserPosition(position);
  }

  @Action(SetWatchId)
  setWatchId(
    { patchState, dispatch }: StateContext<DeliveryStateModel>,
    { watchId }: SetWatchId
  ) {
    patchState({ watchId });
  }

  @Action(ClearWatchId)
  clearWatchId({ patchState, getState }: StateContext<DeliveryStateModel>) {
    const { watchId } = getState();
    navigator.geolocation.clearWatch(watchId);
    patchState({ watchId: null, position: null, bills: null });
  }

  @Action(UpdateRadius)
  updateRadius(
    { patchState }: StateContext<DeliveryStateModel>,
    { radius }: UpdateRadius
  ) {
    patchState({ radius });
  }

  @Action(SetBills)
  setBills(
    { patchState }: StateContext<DeliveryStateModel>,
    { bills }: SetBills
  ) {
    const ids = bills.map((bill) => bill.id);
    return this.api.billsByIds(ids).pipe(
      tap(({ data }) => {
        bills = bills.map((bill) => {
          const order = data.bills.find(
            (xBill) => xBill.FirebaseId_Bill === bill.id
          );
          return { ...bill, order };
        });
        patchState({ bills });
      })
    );
  }

  @Action(CreateDelivery)
  CreateDelivery({ dispatch, getState }: StateContext<DeliveryStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      const {
        bills,
        position: {
          coords: { latitude, longitude },
        },
      } = getState();
      const destinations = bills.reduce((xDestinations, bill) => {
        bill.points.reduce((yDestinations, point) => {
          const existPoint = yDestinations.find(
            (searchPoint) => searchPoint.id === point.id
          );
          if (!existPoint) {
            yDestinations.push({
              id: point.id,
              lat: point.point.geopoint.latitude,
              lng: point.point.geopoint.longitude,
            });
          }
          return yDestinations;
        }, xDestinations);
        return xDestinations;
      }, []);
      this.matrixService.getDistanceMatrix(
        {
          origins: [{ lat: latitude, lng: longitude }],
          destinations,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (res) => {
          const elements = res.rows[0].elements;
          destinations.forEach(
            (point, index) => (point.distance = elements[index].distance.value)
          );
          const minPoint = elements.reduce(
            (min, point) =>
              point.distance.value < min.distance.value ? point : min,
            elements[0]
          );
          const address = destinations.find(
            (destiny) => destiny.distance === minPoint.distance.value
          );
          const ids = bills.map((bill) => bill.billId);
          dispatch(new RegisterDelivery(ids, address.id, token));
        }
      );
    }
  }

  @Action(CalculateNextPoint)
  calculateNextPoint({ getState, dispatch }: StateContext<DeliveryStateModel>) {
    const {
      deliveryOrders,
      deliveryInfo,
      position: {
        coords: { longitude, latitude },
      },
    } = getState();

    if (deliveryOrders.length > 0) {
      const pointsToEvaluate = [];
      deliveryOrders.forEach((xOrder) => {
        const localPoints = [];
        xOrder.Detail.forEach((xDetail) => {
          if (xDetail.State.id !== 6) {
            localPoints.push(xDetail);
          } else {
            pointsToEvaluate.push({
              id: xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                .id,
              type: "place",
              lat: parseFloat(
                xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                  .Lat_Address
              ),
              lng: parseFloat(
                xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                  .Lng_Address
              ),
            });
          }
        });
        if (localPoints.length === xOrder.Detail.length) {
          // Is complete
          const pointExist = pointsToEvaluate.find(
            (point) => point.id === xOrder.Address.id
          );
          if (!pointExist) {
            pointsToEvaluate.push({
              id: xOrder.Address.id,
              type: "destiny",
              lat: Number(xOrder.Address.Lat_Address),
              lng: Number(xOrder.Address.Lng_Address),
            });
          }
        }
      });

      this.matrixService.getDistanceMatrix(
        {
          origins: [{ lat: latitude, lng: longitude }],
          destinations: pointsToEvaluate,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (res) => {
          const rows = res.rows[0].elements;
          pointsToEvaluate.forEach(
            (point, index) => (point.distance = rows[index].distance.value)
          );
          const minPoint = rows.reduce((min, p) =>
            p.distance.value < min.distance.value ? p : rows[0]
          );
          const nextPoint = pointsToEvaluate.find(
            (row) => row.distance === minPoint.distance.value
          );
          dispatch(
            new UpdateNextPointOfDelivery(
              deliveryInfo.id,
              1,
              nextPoint.id,
              nextPoint.type === "place" ? 1 : 2
            )
          );
        }
      );
    } else {
      dispatch(new UpdateDeliveryState(deliveryInfo.id, 4));
      dispatch(new Navigate(["/delivery/map/pending"]));
    }
  }

  @Action(RegisterDelivery)
  registerDelivery(
    { patchState, dispatch }: StateContext<DeliveryStateModel>,
    { billsIds, FK_Address }: RegisterDelivery
  ) {
    return this.api
      .createDelivery({ bills: billsIds, FK_BillState: 6, FK_Address })
      .pipe(
        tap(({ data: { bills } }) => {
          if (bills) {
            patchState({ deliveryOrders: bills, bills: null });
            dispatch(new Navigate(["/delivery/map/info"]));
          }
        }),
        // trace("RegisterDelivery"),
        catchError(() => {
          this.alertService.openSnackBar(
            "Error al crear delivery.",
            "error",
            
          );
          return of(null);
        })
      );
  }

  @Action(ChangeBillDetailState)
  changeBillDetailState(
    { patchState, getState }: StateContext<DeliveryStateModel>,
    { detail, state }: ChangeBillDetailState
  ) {
    const { deliveryOrders } = getState();
    if (deliveryOrders && deliveryOrders.length > 0) {
      const order = deliveryOrders.find((xOrder) =>
        xOrder.Detail.find((xDetail) => xDetail.id === detail.id)
      );
      this.store.dispatch(
        new UpdateBillDetailState(detail.id, state, order.id)
      );
    }
  }

  @Action(GetDeliveryByUser)
  GetDeliveryByUser({
    patchState,
    dispatch,
  }: StateContext<DeliveryStateModel>) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.getDeliveryByUser(token).pipe(
        tap(({ data: { delivery } }) => {
          if (delivery) {
            patchState({ deliveryInfo: delivery });
            dispatch(new GetBillsForDelivery());
            dispatch(new Navigate(["/delivery/map/info"]));
          } else {
            patchState({ deliveryInfo: null });
            dispatch(new Navigate(["/delivery/map/pending"]));
          }
        })
        //trace("GetDeliveryByUser")
      );
    }
  }

  @Action(GetBillsForDelivery)
  GetBillsForDelivery({ patchState }: StateContext<DeliveryStateModel>) {
    const {
      me: {
        DeliveryRole: { Name_Role },
      },
    } = this.store.selectSnapshot(UserState);
    return this.api.getBillsForDelivery().pipe(
      tap(({ data: { bills } }) => {
        if (bills && bills.length > 0) {
          patchState({ deliveryOrders: bills });
        } else {
          patchState({ deliveryOrders: null });
        }
      }),
      // trace("GetBillsForDelivery"),
      catchError((error) => {
        this.alertService.openSnackBar(
          "Error al obtener las órdenes para entrega.",
          "error",
          
        );
        return of(null);
      })
    );
  }
  @Action(UpdateDeliveryState)
  UpdateDeliveryState(
    { patchState, getState }: StateContext<DeliveryStateModel>,
    { id, state }: UpdateDeliveryState
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.updateDeliveryState({ id, FK_DeliveryState: state }).pipe(
        tap(({ data: { delivery } }) => {
          if (delivery) {
            const { deliveryInfo } = getState();
            if (state !== 4) {
              patchState({
                deliveryInfo: {
                  ...deliveryInfo,
                  DeliveryState: delivery.DeliveryState,
                },
              });
            } else {
              patchState({ deliveryInfo: null });
            }
          }
        })
        // trace("UpdateDeliveryState")
      );
    }
  }

  @Action(UpdateBillDetailState)
  UpdateBillDetailState(
    { patchState, getState }: StateContext<DeliveryStateModel>,
    { id, state, billId }: UpdateBillDetailState
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.updateBillDetailState(token, id, state).pipe(
        tap(({ data: { detail } }) => {
          if (detail) {
            let { deliveryOrders } = getState();
            const newDetail = deliveryOrders
              .find((xOrder) => xOrder.id === billId)
              .Detail.map((XDetail) => {
                if (XDetail.id === detail.id) {
                  return { ...XDetail, State: detail.State };
                }
                return XDetail;
              });
            deliveryOrders = deliveryOrders.map((xOrder) => {
              if (xOrder.id === billId) {
                return { ...xOrder, Detail: newDetail };
              }
              return xOrder;
            });
            patchState({ deliveryOrders });
          }
        })
        // trace("UpdateBillDetailState")
      );
    }
  }

  @Action(UpdateNextPointOfDelivery)
  UpdateNextPointOfDelivery(
    { patchState }: StateContext<DeliveryStateModel>,
    {
      id,
      FK_DeliveryState,
      FK_Address,
      TypeNextPoint_Delivery,
    }: UpdateNextPointOfDelivery
  ) {
    const token = this.store.selectSnapshot(UserState.token);

    return this.api
      .updateNextPointOfDelivery({
        id,
        FK_DeliveryState,
        FK_Address,
        TypeNextPoint_Delivery,
      })
      .pipe(
        take(1),
        tap(({ data: { delivery } }) => {
          if (delivery) {
            patchState({ deliveryInfo: delivery });
          }
        })
        //trace("UpdateNextPointOfDelivery")
      );
  }

  @Action(FinishBillDelivery)
  FinishBillDelivery(
    { patchState, getState, dispatch }: StateContext<DeliveryStateModel>,
    { id }: FinishBillDelivery
  ) {
    const token = this.store.selectSnapshot(UserState.token);
    if (token) {
      return this.api.finishBillDelivery(id).pipe(
        tap(({ data: { bill } }) => {
          if (bill) {
            const { deliveryOrders } = getState();
            const newOrders = deliveryOrders.filter(
              (order) => order.id !== bill.id
            );
            patchState({ deliveryOrders: newOrders });
            dispatch(new DeliveryNextPoint(newOrders));
          }
        })
        //trace("FinishBillDelivery")
      );
    }
  }

  @Action(DeliveryNextPoint)
  deliveryNextPoint(
    { getState, dispatch }: StateContext<DeliveryStateModel>,
    { deliveryOrders }: DeliveryNextPoint
  ) {
    const {
      deliveryInfo,
      position: {
        coords: { longitude, latitude },
      },
    } = getState();

    if (deliveryOrders.length > 0) {
      const pointsToEvaluate = [];
      deliveryOrders.forEach((xOrder) => {
        const localPoints = [];
        xOrder.Detail.forEach((xDetail) => {
          if (xDetail.State.id !== 6) {
            localPoints.push(xDetail);
          } else {
            pointsToEvaluate.push({
              id: xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                .id,
              type: "place",
              lat: parseFloat(
                xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                  .Lat_Address
              ),
              lng: parseFloat(
                xDetail.ProductFeature.Product.Inventory.Cellar.Place.Address
                  .Lng_Address
              ),
            });
          }
        });
        if (localPoints.length === xOrder.Detail.length) {
          // Is complete
          pointsToEvaluate.push({
            id: xOrder.Address.id,
            type: "destiny",
            lat: Number(xOrder.Address.Lat_Address),
            lng: Number(xOrder.Address.Lng_Address),
          });
        }
      });

      this.matrixService.getDistanceMatrix(
        {
          origins: [{ lat: latitude, lng: longitude }],
          destinations: pointsToEvaluate,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (res) => {
          const rows = res.rows[0].elements;
          pointsToEvaluate.forEach(
            (point, index) => (point.distance = rows[index].distance.value)
          );
          const minPoint = rows.reduce((min, p) =>
            p.distance.value < min.distance.value ? p : rows[0]
          );
          const nextPoint = pointsToEvaluate.find(
            (row) => row.distance === minPoint.distance.value
          );
          dispatch(
            new UpdateNextPointOfDelivery(
              deliveryInfo.id,
              1,
              nextPoint.id,
              nextPoint.type === "place" ? 1 : 2
            )
          );
        }
      );
    } else {
      dispatch(new UpdateDeliveryState(deliveryInfo.id, 4));
      dispatch(new Navigate(["/delivery/map/pending"]));
    }
  }

  @Action(GetUserForBillDelivery)
  GetUserForBillDelivery(
    { patchState }: StateContext<DeliveryStateModel>,
    { criteria }: GetUserForBillDelivery
  ) {
    return this.api.userByCriteria(criteria).pipe(
      take(1),
      tap(({ data: { UserSelected } }) => {
        if (UserSelected) {
          patchState({ UserSelectedForBill: UserSelected });
        } else {
          this.alertService.openSnackBar(
            "Error al obtener el usuario.",
            "error",
            
          );
        }
      }),
      //trace("GetUserForBillDelivery"),
      catchError(() => {
        this.alertService.openSnackBar(
          "Error al obtener el usuario.",
          "error",
          
        );
        return of(null);
      })
    );
  }

  @Action(UpdateDeliveryCoin)
  UpdateDeliveryCoin(
    { patchState }: StateContext<DeliveryStateModel>,
    { coin }: UpdateDeliveryCoin
  ) {
    patchState({ DeliveryCoin: coin });
  }

  @Action(UpdateBillAsNotDelivered)
  UpdateBillAsNotDelivered(
    { patchState, getState, dispatch }: StateContext<DeliveryStateModel>,
    { id, Description_NotDeliveredBill }: UpdateBillAsNotDelivered
  ) {
    return this.api
      .updateBillAsNotDelivered(id, Description_NotDeliveredBill)
      .pipe(
        tap(({ data: { updated } }) => {
          if (updated) {
            const { deliveryOrders } = getState();
            const newOrders = deliveryOrders.filter((order) => order.id !== id);
            patchState({ deliveryOrders: newOrders });
            dispatch(new CalculateNextPoint());
          } else {
            this.alertService.openSnackBar(
              "Error al registrar.",
              "error",
              
            );
          }
        })
        //trace("UpdateBillAsNotDelivered")
      );
  }

  @Action(GetBillsDelivery)
  getBillsDelivery({ patchState, getState }: StateContext<DeliveryStateModel>) {
    let { bills } = getState();
    const ids = bills.map((bill) => bill.id);
    return this.api.billsByIds(ids).pipe(
      tap(({ data }) => {
        bills = bills.map((bill) => {
          const order = data.bills.find(
            (xBill) => xBill.FirebaseId_Bill === bill.id
          );
          return { ...bill, order };
        });
        patchState({ bills });
      })
    );
  }
}
